// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardInProgressStatusCard_root__g4BsU","text":"PlasmicDashboardInProgressStatusCard_text__Ytpcm"};